import { render, staticRenderFns } from "./BusinessRequirementListModal.vue?vue&type=template&id=091d8fe8"
import script from "./BusinessRequirementListModal.vue?vue&type=script&lang=js"
export * from "./BusinessRequirementListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports